import styled from 'styled-components'

import { deviceMax } from '../../../theme/breakpoints'
import pxToRem from '../../../utils/pxToRem'

import IconButton from '../../IconButton/IconButton'

export const StyledCarrouselSlide = styled.div`
  position: relative;
  height: 150px;
  width: 250px;

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: ${pxToRem(5)};
    object-fit: cover;
  }

  @media ${deviceMax.mobileL} {
    width: 100%;
  }
`

export const StyledIconButton = styled(IconButton)`
  position: absolute;
  bottom: ${pxToRem(4)};
  left: ${pxToRem(4)};
  border-radius: ${pxToRem(5)};
  padding: ${pxToRem(6)};
  background-color: rgba(0, 0, 0, 0.75);

  svg {
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
  }
`
